import React, {useState} from 'react';
import './ShopCrystalsTab.css';
import {CRYSTALS_CONFIGS} from '../../../../configs/crystals';
import {PREMIUM_CONFIGS} from '../../../../configs/premium';
import {PREMIUM} from '../../../../constants/premium';
import ShopCrystalsItem from '../ShopCrystalsItem/ShopCrystalsItem';
import ShopPremiumItem from '../ShopPremiumItem/ShopPremiumItem';
import PremiumInfoModal from '../../../Modals/PremiumInfoModal/PremiumInfoModal';
import CrystalsInfoModal from '../../../Modals/CrystalsInfoModal/CrystalsInfoModal';

const PREMIUM_WITH_CRYSTALS_CONFIG = PREMIUM_CONFIGS.find(
  (premium) => premium.id === PREMIUM.MONTH_12_AND_CRYSTALS_10000
);

function ShopCrystalsTab() {
  // Плашка премиума и здесь открывает модалку с описанием преимуществ —
  // как на вкладке премиума
  const [modalPremium, setModalPremium] = useState(null);
  // Набор кристаллов открывает свою модалку — с описанием, на что их тратят
  const [modalCrystals, setModalCrystals] = useState(null);

  return (
    <div className="shop-tab-content">
      <div className="shop-crystals-grid">
        {CRYSTALS_CONFIGS.map((crystalsConfig) => (
          <ShopCrystalsItem
            key={crystalsConfig.id}
            crystalsConfig={crystalsConfig}
            onItemClick={setModalCrystals}
          />
        ))}
        {PREMIUM_WITH_CRYSTALS_CONFIG && (
          <ShopPremiumItem
            premium={PREMIUM_WITH_CRYSTALS_CONFIG}
            onComingSoonClick={() => setModalPremium(PREMIUM_WITH_CRYSTALS_CONFIG)}
          />
        )}
      </div>

      {modalPremium && (
        <PremiumInfoModal
          premium={modalPremium}
          onClose={() => setModalPremium(null)}
        />
      )}

      {modalCrystals && (
        <CrystalsInfoModal
          crystalsConfig={modalCrystals}
          onClose={() => setModalCrystals(null)}
        />
      )}
    </div>
  );
}

export default ShopCrystalsTab;
